import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { setActiveTab } from '../../calculation/calculation.actions';
import { calculationTypes } from '../../calculation/calculation.constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalculationTypeEnum } from '../../../api/models/calculation-type-enum';

@Component({
  selector: 'rc-landing-page-modal',
  templateUrl: './featured-products-modal.html',
  styleUrls: ['./featured-products-modal.scss'],
})
export class FeaturedProductsModal {
  calculationTypes = calculationTypes;

  constructor(private router: Router, private store: Store<AppState>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  redirectToSelected(roofType: CalculationTypeEnum, link: string[]) {
    this.store.dispatch(setActiveTab({ roofType }));
    if (this.data?.route) {
      link.pop();
      link.push(this.data.route);
    }
    this.router.navigate(link);
  }
}
